import { SVGS } from '@zonofi/zono-money-design-system';
import { OrderData } from '@zonofi/zono-money-helpers';
import { ShippingAddress } from '@zonofi/zono-money-store';
import { isEmpty, isUndefined } from 'lodash';
import React from 'react';

export const OrderDetailsOtherTab: React.FC<{
  orderDetails: OrderData;
  formatShippingAddress: (address?: ShippingAddress) => string;
}> = ({ orderDetails, formatShippingAddress }) => {
  return (
    <div className="order-other-details">
      <div className="order-other-details-header">
        <img src={SVGS.OtherDetailsIcon} alt="" width={20} height={20} />
        <span className="order-other-details-header-text font-primary-semibold">
          Other Details
        </span>
      </div>
      <div className="order-other-details-body">
        <div className="order-other-details-body-item">
          <span className="order-other-details-body-item-heading font-primary-semibold">
            PO Number
          </span>
          <span className="order-other-details-body-item-value font-primary">
            {orderDetails?.poNumber ?? '-'}
          </span>
        </div>
        {!isEmpty(orderDetails?.shippingAddress?.fullName) && (
          <div className="order-other-details-body-item">
            <span className="order-other-details-body-item-heading font-primary-semibold">
              End Customer Name
            </span>
            <span className="order-other-details-body-item-value font-primary">
              {isEmpty(orderDetails?.shippingAddress?.fullName)
                ? '-'
                : (orderDetails?.shippingAddress?.fullName ?? '-')}
            </span>
          </div>
        )}
        {!isEmpty(formatShippingAddress(orderDetails?.shippingAddress)) && (
          <div className="order-other-details-body-item">
            <span className="order-other-details-body-item-heading font-primary-semibold">
              Address
            </span>
            <span className="order-other-details-body-item-value font-primary">
              {formatShippingAddress(orderDetails?.shippingAddress) ?? '-'}
            </span>
          </div>
        )}
        {!isUndefined(orderDetails?.shippingAddress?.latitude) &&
          orderDetails?.shippingAddress?.latitude !== 0 &&
          !isEmpty(orderDetails?.shippingAddress?.latitude?.toString()) && (
            <div className="order-other-details-body-item">
              <span className="order-other-details-body-item-heading font-primary-semibold">
                Lat
              </span>
              <span className="order-other-details-body-item-value font-primary">
                {orderDetails?.shippingAddress?.latitude ?? '-'}
              </span>
            </div>
          )}
        {!isUndefined(orderDetails?.shippingAddress?.longitude) &&
          orderDetails?.shippingAddress?.longitude !== 0 &&
          !isEmpty(orderDetails?.shippingAddress?.longitude?.toString()) && (
            <div className="order-other-details-body-item">
              <span className="order-other-details-body-item-heading font-primary-semibold">
                Long
              </span>
              <span className="order-other-details-body-item-value font-primary">
                {orderDetails?.shippingAddress?.longitude ?? '-'}
              </span>
            </div>
          )}
        {Object.entries(orderDetails?.notes || {}).map(([key, value]) => {
          return (
            <div className="order-other-details-body-item">
              <span className="order-other-details-body-item-heading font-primary-semibold">
                {key}
              </span>
              <span className="order-other-details-body-item-value font-primary">
                {value && value?.toString()?.length !== 0 ? value : '-'}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
